import { message } from 'antd';
import { useEffect } from 'react';

export default function NetworkListener() {

  useEffect(() => {
    // 监听网络状态变化
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
    // 定期检查网络状态
    const timer = setInterval(updateOnlineStatus, 5000);
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
      clearInterval(timer);
    };
  }, []);

  // 检测网络状态变化
  function updateOnlineStatus() {
    if(navigator.onLine) {
      checkConnectionSpeed();
    } else {
      showOffline();
    }
  }
  // 显示断网状态
  function showOffline() {
    const key = 'bad_network_250310';
    // 5分钟之内不再提示
    if(+sessionStorage.getItem(key) > `${Date.now() - 1000 * 60 * 5}`) return;
    message.info('您当前已断网或网络不太好，请检查网络', 5);
    sessionStorage.setItem(key, `${Date.now()}`);
  }
  // 通过加载图片来估算网络速度
  function measureConnectionSpeed() {
    const startTime = performance.now();
    const img = new Image();

    img.onload = function() {
      const endTime = performance.now();
      const duration = endTime - startTime;

      if(duration < 1000) {
        // showGoodConnection('未知');
      } else {
        showSlowConnection('未知');

      }
    };

    img.onerror = function() {
      showSlowConnection('未知');
    };

    // 使用一个小图片来测试加载速度
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  }
  // 显示弱网状态
  function showSlowConnection() {
    showOffline();
  }
  // 检测网络速度
  function checkConnectionSpeed() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    if(connection) {
      const type = connection.effectiveType || connection.type;
      const downlink = connection.downlink;

      if(type === '4g' || (downlink && downlink >= 1)) {
        // showGoodConnection(type, downlink);
      } else {
        showSlowConnection(type, downlink);
      }
    } else {
      // 如果不支持 Network Information API，使用图片加载时间来估算
      measureConnectionSpeed();
    }
  }

  return null;
}
